// Vite style load
import '@styles/pages/search.scss';

import { googlePlacesHelpers } from '@tools/geoservices/google-places-helpers';

window.googlePlacesHelpers = googlePlacesHelpers;
